import { cn } from "../lib/utils";
import { AlertTriangle, ShieldCheck, Activity } from "lucide-react";

export function RiskBadge({ risk, size = "md", className }) {
  const config = {
    low: {
      bg: "bg-emerald-50",
      text: "text-emerald-700",
      ring: "ring-emerald-200",
      icon: ShieldCheck,
      label: "LOW",
    },
    medium: {
      bg: "bg-amber-50",
      text: "text-amber-700",
      ring: "ring-amber-200",
      icon: Activity,
      label: "MEDIUM",
    },
    high: {
      bg: "bg-red-50",
      text: "text-red-700",
      ring: "ring-red-200",
      icon: AlertTriangle,
      label: "HIGH",
    },
  };
  const c = config[risk] || config.medium;
  const Icon = c.icon;
  const sizes = {
    sm: "text-xs px-2 py-0.5 gap-1",
    md: "text-xs px-2.5 py-1 gap-1.5",
    lg: "text-sm px-3 py-1.5 gap-2",
  };
  return (
    <span
      data-testid={`risk-badge-${risk}`}
      className={cn(
        "inline-flex items-center rounded-full font-semibold uppercase tracking-wider ring-1",
        c.bg, c.text, c.ring, sizes[size], className
      )}
    >
      <Icon className={cn(size === "lg" ? "h-4 w-4" : "h-3 w-3")} />
      {c.label}
    </span>
  );
}
